"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var router_history_1 = require("@reverbdotcom/commons/dist/cms/lib/router_history");
var build_root_routes_1 = require("./build_root_routes");
var OFFSET = -60;
function afterRender(cb) {
    setTimeout(function () {
        // Opera Mini :( -- how does anything work for them?
        if (!window.requestAnimationFrame) {
            cb();
            return;
        }
        // Wait two animation frames to help ensure that React
        // has flushed some of the elements to the DOM
        requestAnimationFrame(function () {
            requestAnimationFrame(cb);
        });
    }, 0);
}
// Smooth client side routing for anchor tags, find the specified element
// and scroll the window to the element with a offset after the route
// has been navigated
function scrollToAnchor() {
    afterRender(function () {
        var hash = window.location.hash;
        if (hash !== '') {
            var id = hash.replace('#', '');
            var element = document.getElementById(id);
            if (element) {
                var top_1 = element.getBoundingClientRect().top + window.pageYOffset + OFFSET;
                window.scrollTo({
                    top: top_1,
                    behavior: 'smooth',
                });
            }
        }
    });
}
exports.default = (function (routes, _a) {
    var _b = (_a === void 0 ? {} : _a).onUpdate, onUpdate = _b === void 0 ? function () { } : _b;
    return (function () { return (React.createElement(react_router_1.Router, { onUpdate: function () {
            onUpdate();
            scrollToAnchor();
        }, history: router_history_1.default }, build_root_routes_1.default(routes))); });
});
//# sourceMappingURL=build_reverb_router.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/build_reverb_router.js
// module id = f3QT
// module chunks = 20 21